<template>
  <footer
    class="TheFooter">

    <div
      class="TheFooter_Content">
      <a
        class="TheFooter_Logo"
        href="https://domo.com">
      </a>

      <div
        v-if="items"
        class="TheFooter_Groups"
        key="TheFooter-Groups">

        <div
          v-for="(group, groupIndex) in items"
          class="TheFooter_Group"
          :class="{ 'open': openDrawerIndex === groupIndex}"
          :key="group.title">

          <h4
            class="TheFooter_Group_Title"
            @click="toggleDrawer(groupIndex)">
            {{ group.title }}
          </h4>

          <div
            class="TheFooter_Group_Items-Wrapper"
            :style="computeDrawerStyle(groupIndex)">
            <div
              class="TheFooter_Group_Items"
              ref="groupItems">

              <div
                v-for="item in group.items"
                class="TheFooter_Group_Item"
                v-track-click="{ name: item.label, position: 'footer', path: $route.path }"
                :key="item.label">
                <a
                  class="TheFooter_Group_Item_Anchor MagicUnderline"
                  :href="item.href">
                  {{ item.label }}
                </a>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>

    <div
      class="TheSubFooter">
      <div
        v-if="socials"
        class="TheSubFooter_Socials"
        key="TheSubFooter-Socials">
        <a
          class="TheSubFooter_Socials_Item MagicUnderline"
          v-for="social in socials"
          :key="social.icon"
          :href="social.href"
          :class="social.icon">
        </a>
      </div>

      <p
        class="TheSubFooter_Copyright">
        Copyright &copy; 2011 &mdash; {{ new Date().getFullYear() }} Domo, Inc.
      </p>

      <div
        v-if="privacies"
        class="TheSubFooter_Privacies"
        key="TheSubFooter_Privacies">
        <a
          class="TheSubFooter_Privacies_Item MagicUnderline"
          v-for="privacy in privacies"
          :href="privacy.href"
          target="_blank"
          rel="nofollow"
          :key="privacy.label">
          {{ privacy.label }}
        </a>
      </div>
    </div>

  </footer>
</template>

<script>
export default {
  name: 'TheFooter',

  data() {
    return {
      openDrawerIndex: null,
    };
  },

  props: {
    items:     { type: Array, default: null }, // signature => [{label, href}]
    socials:   { type: Array, default: null }, // signature => [{icon, href}]
    privacies: { type: Array, default: null }, // signature => [{label, href}]
  },

  methods: {
    toggleDrawer(drawerIndex = null) {
      if (drawerIndex === this.openDrawerIndex) {
        this.openDrawerIndex = null;
        return;
      }
      this.openDrawerIndex = drawerIndex;
    },

    computeDrawerStyle(drawerIndex) {
      const computedHeight = drawerIndex === this.openDrawerIndex
        ? this.$refs.groupItems[drawerIndex].offsetHeight
        : 0;
      return {
        height: `${computedHeight}px`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

$transition-duration: .3s;

.TheFooter {
  color: #888;
  text-align: left;
  background-color: #222222;
}

.TheFooter_Content {
  padding: 50px 0;
}

.TheFooter_Logo {
  display: inline-block;
  width: 118px;
  height: 50px;
  margin: 0 20px;
  background-image: url('https://web-assets.domo.com/miyagi/images/logo/brand/color/logo-brand-domo-tbc-horiz-color-white-1.svg');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.TheFooter_Groups {
  position: relative;
  margin-top: 40px;
}

.TheFooter_Group {
  text-align: left;
}

.TheFooter_Group_Title {
  position: relative;
  text-transform: uppercase;
}

.TheFooter_Group_Items-Wrapper {
  overflow: hidden;
  transition: height $transition-duration ease 0s;
}

.TheFooter_Group_Item_Anchor {
  line-height: 32px;
  transition: color $transition-duration ease 0s;
  &:hover {
    color: #9CE;
  }
}

@media only screen and (min-width: 769px) {
  .TheFooter {
    text-align: center;
  }

  .TheFooter_Content {
    padding: 72px 0;
  }

  .TheFooter_Groups {
    display: flex;
    max-width: 1100px;
    padding: 0 20px;
    margin-top: 60px;
    margin-left: auto;
    margin-right: auto;
    justify-content: center;
  }

  .TheFooter_Group {
    flex: 0 1 175px;
    padding: 0 8px;
  }

  .TheFooter_Group_Title {
    color: #FFF;
  }

  .TheFooter_Group_Items-Wrapper {
    height: auto !important;
    margin-top: 14px;
  }
}

@media only screen and (max-width: 768px) {
  .TheFooter_Group {
    padding-left: 20px;
  }

  .TheFooter_Group_Title {
    line-height: 50px;
    cursor: pointer;
    transition: color $transition-duration ease 0s;
    &:after {
      content: '+';
      position: absolute;
      top: 0;
      right: 20px;
      color: #000;
      font-size: 20px;
      transform: rotate(0deg);
      transition: all $transition-duration ease 0s;
    }
  }

  .TheFooter_Group:not(:last-child) .TheFooter_Group_Items-Wrapper {
    border-bottom: 1px solid #000;
  }

  .TheFooter_Group_Items {
    padding-bottom: 20px;
  }

  .TheFooter_Group_Item_Anchor {
    display: block;
    padding-left: 16px;
    line-height: 40px;
    &:after {
      display: none !important;
    }
  }

  .TheFooter_Group.open {
    .TheFooter_Group_Title {
      color: #9CE;
    }
    .TheFooter_Group_Title:after {
      color: #9CE;
      transform: rotate(-135deg);
    }
  }
}

// Sub-Footer
.TheSubFooter {
  padding: 50px 16px;
  color: #555555;
  text-align: center !important;
  background-color: rgba($black, .38);
}

.TheSubFooter_Socials {
  font-size: 24px;
  color: $white;
}

.TheSubFooter_Socials_Item {
  display: inline-block;
  & + .TheSubFooter_Socials_Item {
    margin-left: 30px;
  }
  &:hover {
    color: #88BBDD;
    transition: color $transition-duration ease 0s;
  }
}

.TheSubFooter_Copyright {
  margin-top: 32px;
}

.TheSubFooter_Privacies_Item {
  display: inline-block;
  position: relative;
  transition: color $transition-duration ease 0s;
  &:hover {
    color: $white;
  }
  & + .TheSubFooter_Privacies_Item {
    margin-left: 16px;
  }
  & + .TheSubFooter_Privacies_Item:before {
    content: '|';
    position: absolute;
    left: -12px;
    color: #555555;
  }
  &:after {
    background-color: $white !important;
  }
}

.MagicUnderline {
  position: relative;
  &:hover:after {
    width: 100%;
  }
  &:after {
    content: '';
    position: absolute;
    width: 0%;
    height: 1px;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    background-color: #88BBDD;
    transition: width $transition-duration ease 0s;
  }
}
</style>
